import styled from 'styled-components';

export const Fullscreen = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const Main = styled(({className, children}) => (
    <main className={className}>
        <div>{children}</div>
    </main>
))`
  width: calc(100% - 42px);
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: normal;
  align-items: center;
  color: ${({theme}) => theme.color.name === 'dark' ? theme.white_0 : theme.blue_1};
  margin: 0 auto;
  margin-top: 4px;
  & > div {
    width: 100%;
  }
  p {
    text-align: center;
    font-size: 15px;
  }
  h1 {
    margin: 0 0 16px 0;
    font-weight: 500;
    font-size: 23px;
    text-align: center;
  }
`;

export const Footer = styled(({className, children}) => (
    <footer className={className}>
        <div>{children}</div>
    </footer>
))`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: ${({theme}) => theme.color.name === 'dark' ? theme.white_0 : theme.blue_1};
  font-size: 14px;
  text-align: center;
  & > *:last-child {
    width: 100%;
    margin-bottom: 36px;
  }
`;
